import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App as VedaApp, ContextProvider, AuthProvider, setExtraRoutes, setExtraLinks, setExtraMaintenanceLinks, setExtraSearchEntities, setExtraOverviewWidgets, Spinner, useAuthContext } from '@veda/dashboard-ui';
import LoginPage from './modules/operatore/pages/LoginPage';
import LoginSuperadmin from './modules/operatore/pages/LoginSuperadmin';
import ResetPasswordPage from './modules/operatore/pages/ResetPasswordPage';
import OperatoreRegistrazione from './modules/operatore/pages/OperatoreRegistrazione';
import AccettaInvitoPage from './modules/operatore/pages/AccettaInvitoPage';
import EntiList from './modules/ppp/pages/EntiList';
import CompanyAdminList from './modules/ppp/pages/CompanyAdminList';
import AccettaInvitoPaPage from './modules/pa/pages/AccettaInvitoPaPage';
import AccettaInvitoRupPage from './modules/pa/pages/AccettaInvitoRupPage';
import RichiestaAccessoRupPage from './modules/pa/pages/RichiestaAccessoRupPage';
import RichiesteAccessoRupList from './modules/pa/pages/RichiesteAccessoRupList';
import PaCallbackPage from './modules/pa/pages/PaCallbackPage';
import MioEntePage from './modules/pa/pages/MioEntePage';
import MembriEntePage from './modules/pa/pages/MembriEntePage';
import RupEntePage from './modules/pa/pages/RupEntePage';
import MieiEntiPage from './modules/pa/pages/MieiEntiPage';
import OperatoreProfilo from './modules/operatore/pages/OperatoreProfilo';
import CompanyPage from './modules/operatore/pages/CompanyPage';
import ProposteListPage from './modules/operatore/pages/ProposteListPage';
import WizardProposta from './modules/operatore/pages/WizardProposta';
import PropostaAvanzamentoPage from './modules/operatore/pages/PropostaAvanzamentoPage';
import OperatoreNotifichePage from './modules/operatore/pages/OperatoreNotifichePage';
import OperatoreAvvisiPage from './modules/operatore/pages/OperatoreAvvisiPage';
import OperatoreAvvisoDetailPage from './modules/operatore/pages/OperatoreAvvisoDetailPage';
import AvvisiPublicPage from './modules/ppp/pages/AvvisiPublicPage';
import AvvisoPublicDetailPage from './modules/ppp/pages/AvvisoPublicDetailPage';
import loginBg from './assets/login-bg.svg';
import { MdOutlineAccountBalance, MdAssignment, MdWarning, MdCalendarMonth, MdDescription, MdCampaign, MdInbox, MdVisibility, MdBarChart, MdBusiness, MdAccountBalance, MdGroup } from 'react-icons/md';
import ProcedimentiList from './modules/ppp/pages/ProcedimentiList';
import ProcedimentoDetail from './modules/ppp/pages/ProcedimentoDetail';
import ProcedimentiAssegnati from './modules/ppp/pages/ProcedimentiAssegnati';
import ReportRitardiRup from './modules/ppp/pages/ReportRitardiRup';
import ReportisticaPage from './modules/ppp/pages/ReportisticaPage';
import ReportAvanzamento from './modules/ppp/pages/ReportAvanzamento';
import ReportTermini from './modules/ppp/pages/ReportTermini';
import ReportPerformanceRup from './modules/ppp/pages/ReportPerformanceRup';
import ReportPubblicazioni from './modules/ppp/pages/ReportPubblicazioni';
import ReportStatistiche from './modules/ppp/pages/ReportStatistiche';
import ProgrammazioneList from './modules/ppp/pages/ProgrammazioneList';
import ProgrammazioneDetail from './modules/ppp/pages/ProgrammazioneDetail';
import DipList from './modules/ppp/pages/DipList';
import DipDetail from './modules/ppp/pages/DipDetail';
import AvvisoPubblicoList from './modules/ppp/pages/AvvisoPubblicoList';
import AvvisoPubblicoDetail from './modules/ppp/pages/AvvisoPubblicoDetail';
import ProposteList from './modules/ppp/pages/ProposteList';
import PropostaDetail from './modules/ppp/pages/PropostaDetail';
import SchemaValutazioneDetail from './modules/ppp/pages/SchemaValutazioneDetail';
import VerbaleValutazioneDetail from './modules/ppp/pages/VerbaleValutazioneDetail';
import { ProcedimentiAttiviWidget, ScadenzeCriticheWidget, RitardiWidget } from './modules/ppp/components/DashboardWidgets';
import { KanbanFasiWidget, ScadenzeImminentiWidget, KpiFasiWidget } from './modules/ppp/components/DashboardWidgetsExtra';
import NotifichePage from './modules/ppp/pages/NotifichePage';
import NotificheBadgeIcon from './modules/ppp/components/NotificheBadgeIcon';
import { pppLanguages } from './modules/ppp/languages';
import { useAuthUser } from './modules/ppp/hooks/useAuthUser';
import { buildSidebarLinks } from './modules/ppp/data/sidebarLinks';

// Le route sono invarianti rispetto ai permessi — il backend protegge gli endpoint.
setExtraRoutes([
  { path: 'ppp',                     element: <ProcedimentiList /> },
  { path: 'ppp/assegnati',           element: <ProcedimentiAssegnati /> },
  { path: 'ppp/report-ritardi',            element: <ReportRitardiRup /> },
  { path: 'ppp/report',                    element: <ReportisticaPage /> },
  { path: 'ppp/report/avanzamento',        element: <ReportAvanzamento /> },
  { path: 'ppp/report/termini',            element: <ReportTermini /> },
  { path: 'ppp/report/performance-rup',    element: <ReportPerformanceRup /> },
  { path: 'ppp/report/pubblicazioni',      element: <ReportPubblicazioni /> },
  { path: 'ppp/report/statistiche',        element: <ReportStatistiche /> },
  { path: 'ppp/programmazione',      element: <ProgrammazioneList /> },
  { path: 'ppp/programmazione/:id',  element: <ProgrammazioneDetail /> },
  { path: 'ppp/avvisi-pubblici',     element: <AvvisoPubblicoList /> },
  { path: 'ppp/avvisi-pubblici/:id', element: <AvvisoPubblicoDetail /> },
  { path: 'ppp/dip',                 element: <DipList /> },
  { path: 'ppp/dip/:id',            element: <DipDetail /> },
  { path: 'ppp/proposte',                                        element: <ProposteList /> },
  { path: 'ppp/proposte/:id',                                    element: <PropostaDetail /> },
  { path: 'ppp/notifiche',                                       element: <NotifichePage /> },
  { path: 'ppp/:procedimentoId/schemi-valutazione/:schemaId',    element: <SchemaValutazioneDetail /> },
  { path: 'ppp/:procedimentoId/verbali-valutazione/:verbaleId',  element: <VerbaleValutazioneDetail /> },
  { path: 'ppp/:id',                                             element: <ProcedimentoDetail /> },
  // Profilo operatore economico — dentro DashboardLayout Veda, sidebar vuota
  { path: 'operatore/profilo',  element: <OperatoreProfilo /> },
  { path: 'operatore/company',  element: <CompanyPage /> },
  // Proposte lato operatore (art. 193) — lista + wizard + avanzamento
  { path: 'operatore/proposte',               element: <ProposteListPage /> },
  { path: 'operatore/proposte/nuova',         element: <WizardProposta /> },
  { path: 'operatore/proposte/:id/modifica',  element: <WizardProposta /> },
  { path: 'operatore/proposte/:id',           element: <PropostaAvanzamentoPage /> },
  { path: 'operatore/notifiche',              element: <OperatoreNotifichePage /> },
  { path: 'operatore/avvisi',               element: <OperatoreAvvisiPage /> },
  { path: 'operatore/avvisi/:id',           element: <OperatoreAvvisoDetailPage /> },
  // Area PA — amministratore e utenti ente
  { path: 'pa/ente',            element: <MioEntePage /> },
  { path: 'pa/membri',          element: <MembriEntePage /> },
  { path: 'pa/rup-associati',   element: <RupEntePage /> },
  { path: 'pa/miei-enti',       element: <MieiEntiPage /> },
  // Anagrafica enti (superadmin/rup)
  { path: 'ppp/enti',           element: <EntiList /> },
  // Operatori economici / company (superadmin)
  { path: 'ppp/companies',      element: <CompanyAdminList /> },
  // Richieste di accesso RUP (superadmin)
  { path: 'pa/richieste-rup',   element: <RichiesteAccessoRupList /> },
]);

setExtraOverviewWidgets([
  ProcedimentiAttiviWidget,
  ScadenzeCriticheWidget,
  RitardiWidget,
  KanbanFasiWidget,
  ScadenzeImminentiWidget,
  KpiFasiWidget,
]);

setExtraSearchEntities([
  { label: 'PROCEDIMENTI', icon: MdOutlineAccountBalance },
]);

// Voce PPP nella sidebar del superadmin (gestione enti e inviti)
setExtraMaintenanceLinks([{
  title: 'PPP',
  links: [
    { name: 'ppp/enti', label: 'Enti PA', icon: <MdAccountBalance />, end: false },
    { name: 'ppp/companies', label: 'Operatori Economici', icon: <MdBusiness />, end: false },
    { name: 'pa/richieste-rup', label: 'Richieste accesso', icon: <MdGroup />, end: false },
  ],
}]);

// Configura la sidebar in base al ruolo dell'utente loggato.
// VedaApp viene montato solo dopo aver settato i link, così la Sidebar legge
// getLinks() quando la variabile module-level è già aggiornata.
function PppSidebarLoader() {
  const { user, can, ready } = useAuthUser();

  if (!ready) return <Spinner />;

  setExtraLinks(buildSidebarLinks(user, can));

  return <VedaApp />;
}

function AppInner() {
  const { userKey, isLogged } = useAuthContext();

  // Le tab condividono storage e cookie di sessione: se in un'altra tab si fa
  // logout+login con un account diverso, AuthProvider aggiorna isLogged (evento
  // storage) ma questa tab resterebbe renderizzata con l'identità vecchia
  // mentre le richieste partono con la nuova. Ricarichiamo per riallinearci.
  useEffect(() => {
    if (isLogged && userKey && isLogged.id && isLogged.id !== userKey) {
      window.location.reload();
    }
  }, [isLogged, userKey]);

  return <PppSidebarLoader key={userKey} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ContextProvider consumerLanguages={pppLanguages} loginImage={loginBg}>
        <AuthProvider>
          <Routes>
            {/* Login unico con SPID — per tutti gli utenti non-superadmin */}
            <Route path="/login"                       element={<LoginPage />} />
            {/* Login superadmin — URL non linkato, solo email+password Veda */}
            <Route path="/superadmin"                  element={<LoginSuperadmin />} />
            {/* Reimpostazione password da mail — pubblica. Il token arriva come
                query param (?token=), come lo genera SendPasswordResetEmail. */}
            <Route path="/reset-password"              element={<ResetPasswordPage />} />
            {/* Retrocompatibilità vecchi link */}
            <Route path="/operatore-login"             element={<Navigate to="/login" replace />} />
            <Route path="/operatore-registrazione"     element={<OperatoreRegistrazione />} />
            {/* Pagina accettazione invito operatore — pubblica */}
            <Route path="/operatore/invito/:token"     element={<AccettaInvitoPage />} />
            {/* Pagina accettazione invito Amministratore Ente / Membro Ente — pubblica */}
            <Route path="/pa/invito/:token"            element={<AccettaInvitoPaPage />} />
            {/* Pagina primo accesso RUP da invito ente — pubblica */}
            <Route path="/rup/invito/:token"           element={<AccettaInvitoRupPage />} />
            {/* Pagine pubbliche avvisi PPP — no auth */}
            <Route path="/avvisi"                      element={<AvvisiPublicPage />} />
            <Route path="/avvisi/:uuid"                element={<AvvisoPublicDetailPage />} />
            {/* Callback SPID per amministratore ente — riceve token/user dal backend */}
            <Route path="/pa/callback"                 element={<PaCallbackPage />} />
            {/* Form pubblico richiesta accesso RUP (auto-registrazione) */}
            <Route path="/pa/richiesta-rup"            element={<RichiestaAccessoRupPage />} />
            <Route path="*"                            element={<AppInner />} />
          </Routes>
        </AuthProvider>
      </ContextProvider>
    </BrowserRouter>
  );
}
